import { IModel } from '@/@types/models/model';
import coreFields from '../helpers/coreFields';
import buttonFields from '../helpers/buttonFields';
import commonFields from '../helpers/commonFields';

const Umrli: IModel = {
  title: 'Registar umrlih',
  apiPath: 'groblja/registar-umrlih',
  forms: {
    default: {
      fields: [
        'oib',
        'groblje_id',
        'ime',
        'prezime',
        'prezime_ime',
        'prezime_prije_braka',
        'ime_oca',
        'spol',
        'datum_rodenja',
        'godina_rodenja',
        'vjeroispovijest',
        'ulica',
        'mjesto',
        'ptt',
        'drzava',
        // 'adresa_full',
        'bracno_stanje',
        'ime_bracnog_druga',
        'prezime_bracnog_druga',
        'prezime_ime_bracnog_druga',
        'datum_smrti',
        'godina_smrti',
        'uzrok_smrti',
        'mjesto_smrti',
        'mjesto_ukopa',
        'pogrebnik_dopremio',
        'registar_broj',
        'registar_strana',
        'registar_redni_broj',
        'napomena',
      ],
    },
    insert: {
      fields: [
        'oib',
        'groblje_id',
        'ime',
        'prezime',
        'prezime_prije_braka',
        'ime_oca',
        'spol',
        'datum_rodenja',
        'godina_rodenja',
        'vjeroispovijest',
        'ulica',
        'mjesto',
        'ptt',
        'drzava',
        'bracno_stanje',
        'ime_bracnog_druga',
        'prezime_bracnog_druga',
        'datum_smrti',
        'godina_smrti',
        'uzrok_smrti',
        'mjesto_smrti',
        'mjesto_ukopa',
        'pogrebnik_dopremio',
        'registar_broj',
        'registar_strana',
        'registar_redni_broj',
        'napomena',
      ],
      layout: [
        { 
          title: 'groblja:sections.podaci_o_umrlom',
          columns: 3,
          fieldNames: ['oib', 'ime','prezime','ime_oca', 'spol','datum_rodenja','godina_rodenja', 'vjeroispovijest', 'ulica','mjesto','ptt', 'drzava']
        },
        {
          title: 'groblja:sections.bracno_stanje',
          columns: 2,
          fieldNames: ['bracno_stanje', 'prezime_prije_braka', 'ime_bracnog_druga', 'prezime_bracnog_druga']
        },
        {
          
          title: 'groblja:sections.podaci_o_smrti',
          columns: 3,
          fieldNames: ['datum_smrti','godina_smrti', 'mjesto_smrti', 'uzrok_smrti']
        },
        { 
          title: 'groblja:sections.ukop',
          columns: 2,
          fieldNames: ['groblje_id','mjesto_ukopa','pogrebnik_dopremio']
        }, 
        {
          title: 'groblja:sections.registar',
          columns: 3,
          fieldNames: ['registar_broj','registar_strana','registar_redni_broj']
        },
        { 
          title: 'common.ostalo',
          columns: 1,
          fieldNames: ['napomena']
        }
        
      ]
    },
    update: {
      fields: [
        'oib',
        'groblje_id',
        'ime',
        'prezime',
        'prezime_prije_braka',
        'ime_oca',
        'spol',
        'datum_rodenja',
        'godina_rodenja',
        'vjeroispovijest',
        'ulica',
        'mjesto',
        'ptt',
        'drzava',
        'adresa_full',
        'bracno_stanje',
        'ime_bracnog_druga',
        'prezime_bracnog_druga',
        'prezime_ime_bracnog_druga',
        'datum_smrti',
        'godina_smrti',
        'uzrok_smrti',
        'mjesto_smrti',
        'mjesto_ukopa',
        'pogrebnik_dopremio',
        'registar_broj',
        'registar_strana',
        'registar_redni_broj',
        'napomena',
      ],
      layout: [
        { 
          title: 'groblja:sections.podaci_o_umrlom',
          columns: 3,
          fieldNames: ['oib', 'ime','prezime', 'ime_oca', 'spol','datum_rodenja','godina_rodenja', 'vjeroispovijest', 'ulica','mjesto','ptt', 'drzava', 'adresa_full']
        },
        {
          title: 'groblja:sections.bracno_stanje',
          columns: 2,
          fieldNames: ['bracno_stanje', 'prezime_prije_braka', 'ime_bracnog_druga', 'prezime_bracnog_druga']
        },
        {
          
          title: 'groblja:sections.podaci_o_smrti',
          columns: 3,
          fieldNames: ['datum_smrti','godina_smrti', 'mjesto_smrti', 'uzrok_smrti']
        },
        { 
          title: 'groblja:sections.ukop',
          columns: 2,
          fieldNames: ['groblje_id','mjesto_ukopa','pogrebnik_dopremio']
        }, 
        {
          title: 'groblja:sections.registar',
          columns: 3,
          fieldNames: ['registar_broj','registar_strana','registar_redni_broj']
        },
        { 
          title: 'common.ostalo',
          columns: 1,
          fieldNames: ['napomena']
        }
        
      ]
    },
  },
  listViews: {
    default: {
      fields: [
        'id',
        'groblje_id',
        'oib',
        'ime',
        'prezime',
        'prezime_ime',
        'prezime_prije_braka',
        'ime_oca',
        'spol',
        'datum_rodenja',
        'godina_rodenja',
        'vjeroispovijest',
        'ulica',
        'mjesto',
        'ptt',
        'drzava',
        'adresa_full',
        'bracno_stanje',
        'ime_bracnog_druga',
        'prezime_bracnog_druga',
        'prezime_ime_bracnog_druga',
        'datum_smrti',
        'godina_smrti',
        'uzrok_smrti',
        'mjesto_smrti',
        'mjesto_ukopa',
        'pogrebnik_dopremio',
        'registar_broj',
        'registar_strana',
        'registar_redni_broj',
        'napomena',
        'docs',
        'btn_show_history',
      ],
      hidden: ['id', 'prezime_ime_bracnog_druga', 'registar_broj', 'registar_strana', 'registar_redni_broj'],
    },
    history: {
      fields: [
        'oib',
        'groblje_id',
        'ime',
        'prezime',
        'prezime_ime',
        'prezime_prije_braka',
        'ime_oca',
        'spol',
        'datum_rodenja',
        'godina_rodenja',
        'vjeroispovijest',
        'ulica',
        'mjesto',
        'ptt',
        'drzava',
        'adresa_full',
        'bracno_stanje',
        'ime_bracnog_druga',
        'prezime_bracnog_druga',
        'prezime_ime_bracnog_druga',
        'datum_smrti',
        'godina_smrti',
        'uzrok_smrti',
        'mjesto_smrti',
        'mjesto_ukopa',
        'pogrebnik_dopremio',
        'registar_broj',
        'registar_strana',
        'registar_redni_broj',
        'napomena',
        'docs',
        'edited',
      ],
      hidden: ['id', 'prezime_ime_bracnog_druga', 'registar_broj', 'registar_strana', 'registar_redni_broj'],
    },
  },
  fields: [
    coreFields.id,
    {
      title: 'oib',
      source: 'oib',
      ttoken: 'groblja:registar_umrlih.oib',
      type: 'text',
      filter: true,
    },
    {
      title: 'ime',
      source: 'ime',
      ttoken: 'groblja:registar_umrlih.ime',
      type: 'text',
      filter: true,
      validation: {
        required: true,
      },
    },
    {
      title: 'prezime',
      source: 'prezime',
      ttoken: 'groblja:registar_umrlih.prezime',
      type: 'text',
      filter: true,
      validation: {
        required: true,
      },
    },
    {
      type: 'boolean',
      source: 'has_history',
      title: 'has history',
      ttoken: 'common.has_history',
    },
    {
      title: 'prezime_ime',
      source: 'prezime_ime',
      ttoken: 'groblja:registar_umrlih.prezime_ime',
      type: 'text',
      filter: true,
    },
    {
      title: 'prezime_prije_braka',
      source: 'prezime_prije_braka',
      ttoken: 'groblja:registar_umrlih.prezime_prije_braka',
      type: 'text',
      filter: true,
    },
    {
      title: 'ime_oca',
      source: 'ime_oca',
      ttoken: 'groblja:registar_umrlih.ime_oca',
      type: 'text',
      filter: true,
    },
    {
      title: 'spol',
      source: 'spol',
      ttoken: 'groblja:registar_umrlih.spol',
      type: 'picker',
      items: {
        labels: ['MUŠKO', 'ŽENSKO', 'OSTALO'],
        values: ['MUŠKO', 'ŽENSKO', 'OSTALO'],
      },
      filter: true,
      validation: {
        required: true,
      },
    },
    {
      title: 'datum_rodenja',
      source: 'datum_rodenja',
      ttoken: 'groblja:registar_umrlih.datum_rodenja',
      type: 'date',
      filter: true,
    },
    {
      title: 'godina_rodenja',
      source: 'godina_rodenja',
      ttoken: 'groblja:registar_umrlih.godina_rodenja',
      type: 'numeric',
      filterType: 'text',
      filter: true,
    },
    {
      title: 'vjeroispovijest',
      source: 'vjeroispovijest',
      ttoken: 'groblja:registar_umrlih.vjeroispovijest',
      type: 'text',
      filter: true,
    },
    {
      title: 'ulica',
      source: 'ulica',
      ttoken: 'groblja:registar_umrlih.ulica',
      type: 'text',
      filter: true,
    },
    {
      title: 'mjesto',
      source: 'mjesto',
      ttoken: 'groblja:registar_umrlih.mjesto',
      type: 'text',
      filter: true,
    },
    {
      title: 'ptt',
      source: 'ptt',
      ttoken: 'common.postanski_broj',
      type: 'numeric',
      filterType: 'text',
      filter: true,
    },
    {
      title: 'drzava',
      source: 'drzava',
      ttoken: 'groblja:registar_umrlih.drzava',
      type: 'text',
      filter: true,
    },
    {
      title: 'adresa_full',
      source: 'adresa_full',
      ttoken: 'groblja:registar_umrlih.adresa_full',
      type: 'text',
      filter: true,
    },
    {
      title: 'groblje_id',
      source: 'groblje_id',
      ttoken: 'groblja:grobna_mjesta.groblje',
      type: 'picker',
      subModel: {
        apiPath: 'groblja?view=picker',
        format: '{label}',
        idattr: 'id',
      },
      validation: {
        required: true,
      },
      filter: true,
    },
    {
      title: 'bracno_stanje',
      source: 'bracno_stanje',
      ttoken: 'groblja:registar_umrlih.bracno_stanje',
      type: 'picker',
      items: {
        labels: ['SLOBODAN', 'OŽENJEN', 'RAZVEDEN', 'UDOVAC/UDOVICA'],
        values: ['SLOBODAN', 'OŽENJEN', 'RAZVEDEN', 'UDOVAC/UDOVICA'],
      },
      filter: true,
    },
    {
      title: 'ime_bracnog_druga',
      source: 'ime_bracnog_druga',
      ttoken: 'groblja:registar_umrlih.ime_bracnog_druga',
      type: 'text',
      filter: true,
    },
    {
      title: 'prezime_bracnog_druga',
      source: 'prezime_bracnog_druga',
      ttoken: 'groblja:registar_umrlih.prezime_bracnog_druga',
      type: 'text',
      filter: true,
    },
    {
      title: 'prezime_ime_bracnog_druga',
      source: 'prezime_ime_bracnog_druga',
      ttoken: 'groblja:registar_umrlih.prezime_ime_bracnog_druga',
      type: 'text',
      filter: true,
    },
    {
      title: 'datum_smrti',
      source: 'datum_smrti',
      ttoken: 'groblja:registar_umrlih.datum_smrti',
      type: 'date',
      filter: true,
    },
    {
      title: 'godina_smrti',
      source: 'godina_smrti',
      ttoken: 'groblja:registar_umrlih.godina_smrti',
      type: 'numeric',
      filterType: 'text',
      filter: true,
    },
    {
      title: 'uzrok_smrti',
      source: 'uzrok_smrti',
      ttoken: 'groblja:registar_umrlih.uzrok_smrti',
      type: 'text',
      filter: true,
      width: 'full'
    },
    {
      title: 'mjesto_smrti',
      source: 'mjesto_smrti',
      ttoken: 'groblja:registar_umrlih.mjesto_smrti',
      type: 'text',
      filter: true,
    },
    {
      title: 'mjesto_ukopa',
      source: 'mjesto_ukopa',
      ttoken: 'groblja:registar_umrlih.mjesto_ukopa',
      type: 'text',
      filter: true,
    },
    {
      title: 'pogrebnik_dopremio',
      source: 'pogrebnik_dopremio',
      ttoken: 'groblja:registar_umrlih.pogrebnik_dopremio',
      type: 'text',
      filter: true,
    },
    {
      title: 'registar_broj',
      source: 'registar_broj',
      ttoken: 'groblja:registar_umrlih.registar_broj',
      type: 'numeric',
      filterType: 'text',
      filter: true,
    },
    {
      title: 'registar_strana',
      source: 'registar_strana',
      ttoken: 'groblja:registar_umrlih.registar_strana',
      type: 'numeric',
      filterType: 'text',
      filter: true,
    },
    {
      title: 'registar_redni_broj',
      source: 'registar_redni_broj',
      ttoken: 'groblja:registar_umrlih.registar_redni_broj',
      type: 'numeric',
      filterType: 'text',
      filter: true,
    },
    {
      title: 'napomena',
      source: 'napomena',
      ttoken: 'groblja:registar_umrlih.napomena',
      type: 'multiline',
      rows: 3,
      maxRows: 10,
      width: 'full',
      filter: true,
    },
    {
      title: 'is_deleted',
      source: 'is_deleted',
      ttoken: '',
      type: 'boolean',
      items: {
        labels: ['common.no', 'common.yes'],
        values: [false, true],
        default: false,
      },
      filter: true,
      readonly: true,
    },
    {
      title: 'edited',
      source: 'edited',
      ttoken: 'common.edited',
      type: 'datetime',
      filter: true,
    },
    {
      title: 'action',
      source: 'action',
      ttoken: 'common.action',
      type: 'picker',
      items: {
        labels: ['common.actions.update', 'common.actions.insert', 'common.actions.delete'],
        values: ['UPDATE', 'INSERT', 'DELETE'],
      },
      filter: true,
      translate: true,
      readonly: true,
    },
    coreFields.gid,
    commonFields.docsHistory,
    coreFields.created_by,
    coreFields.created_on,
    coreFields.modified_by,
    coreFields.modified_on,
    buttonFields.show_history,
  ],
};

export default Umrli;
